<header class="list-header">
  <div class="header-content">
    <h1 class="heading">{{ 'ANSWER_TEMPLATES' | translate }}</h1>

    <ask-button *ngIf="companies.length > 1" type="livechat" size="xsmall" [rounded]="true"
      [askDropdown]="companiesDropdown" [positions]="DROPDOWN_POSITIONS" (onClick)="logCompanyFilterOpening()">
      {{ selectedCompany?.companyName || ('ALL_COMPANIES_SELECTED' | translate) }}
      <span class="material-icons notranslate">expand_more</span>
    </ask-button>
  </div>

  <div class="header-content">
    <a *ngIf="userCanAccessManageScreen" class="manage-link" [href]="URL_TEMPLATES_MANAGEMENT" target="_blank"
      (click)="logManagementScreenClick()">
      <ask-button class="header-button" type="icon-only" size="small">
        <span class="material-icons notranslate icon -settings">settings</span>
        {{ 'MANAGE_TEMPLATES' | translate }}
      </ask-button>
    </a>

    <ask-button class="header-button" type="icon-only" size="small" (onClick)="refreshList()">
      <span class="material-icons notranslate icon -settings">refresh</span>
      {{ 'REFRESH_LIST' | translate }}
    </ask-button>

    <ask-button class="header-button" type="icon-only" size="small" (onClick)="handleNewTemplateClick()">
      <span class="material-icons notranslate icon -new">add_circle</span>
      {{ 'NEW_TEMPLATE' | translate }}
    </ask-button>
  </div>
</header>

<main class="template-list" #templateList>
  <div class="loading-container" *ngIf="!answerTemplates">
    <ask-skeleton class="skeleton" [barsHeight]="49"></ask-skeleton>
  </div>

  <p class="nodata" *ngIf="answerTemplates?.length === 0">
    {{ 'ANSWER_TEMPLATE_LIST_NO_DATA' | translate }}
  </p>

  <ng-container *ngIf="answerTemplates?.length">
    <div *ngFor="let template of answerTemplates; index as index; trackBy: answerTemplateIndex" class="template-item"
      (click)="selectTemplate(template)" [class.-active]="selectedIndex === index" (mouseenter)="focusOn(index)">
      <div class="template-data">
        <p class="template-name">
          /{{ template.title }}
          <span class="companies">.
            {{ (template.companyNames || '') | translate }}
          </span>
        </p>

        <div class="template-text">
          <span class="material-icons notranslate icon icon-info" data-testid="check"  askTooltip
            [askTooltipMessage]="'ALERT_LIMIT_CHARACTERS.CHECK_TOOLTIP' | translate" [askTooltipPosition]="'after'"
            *ngIf="!template.exceededLimitAttendance"> check </span>
          <span class="material-icons notranslate icon icon-info" data-testid="info" askTooltip
            [askTooltipMessage]="'ALERT_LIMIT_CHARACTERS.INFO_TOOLTIP' | translate" [askTooltipPosition]="'after'"
            *ngIf="template.exceededLimitAttendance"> info </span>
          <p class="text">{{ template.content | htmlStrip }}</p>
        </div>
      </div>

      <div class="template-actions">
        <ask-button type="icon-only" size="small" (onClick)="handleDeleteTemplateClick($event, template)">
          <span class="material-icons notranslate icon">delete</span>
        </ask-button>

        <ask-button type="icon-only" size="small" (onClick)="handleEditTemplateClick($event, template)">
          <span class="material-icons notranslate icon">edit</span>
        </ask-button>
      </div>
    </div>
  </ng-container>
</main>

<ng-template #companiesDropdown>
  <div class="company-selector">
    <ask-button type="dropdown" class="company-button" (onClick)="selectCompany()">
      {{ 'ALL_COMPANIES_SELECTED' | translate }}
    </ask-button>

    <ask-button type="dropdown" class="company-button" (onClick)="selectCompany(currentAttendanceCompany)">
      {{ currentAttendanceCompany?.companyName }}
    </ask-button>
  </div>
</ng-template>